import classNames from 'classnames';
import React from 'react';
import styles from './Emoji.module.scss';

export interface EmojiProps {
  symbol: string;
  label: string;
  style?: React.CSSProperties;
  className?: string;
}

/***
 * Simple wrapper to render Emoji's with recommended aria labels etc.
 * Find your favourite here: https://emojipedia.org
 * @param props
 * @returns {*}
 * @constructor
 */
const Emoji = (props: EmojiProps) => (
  <span
    className={classNames(styles.emoji, props.className)}
    style={props.style}
    role="img"
    aria-label={props.label}
    aria-hidden={props.label ? 'false' : 'true'}
  >
    {props.symbol}
  </span>
);

export default Emoji;
